import smoothscroll from 'smoothscroll-polyfill';
export default {
  mounted() {
    smoothscroll.polyfill();
  }
};